// eslint-disable-next-line import/prefer-default-export
export const AREA_TYPE = {
  DYNAMIC: 'DYNAMIC',
  STATIC: 'STATIC',
};
